import { useQueryPublicSystemSettings } from "src/queries/platform/system.query";
import { setCostUnitLabel } from "@utils/number";

/**
 * Applies the tenant's cost sign to every formatCurrency call. The default lives
 * in the DB, not here: new tenants get "Ð", tenants that predate the column were
 * backfilled to "" and keep real currency formatting.
 * Assigning during render (not in an effect) so the render that receives the
 * setting already paints with it; the write is idempotent.
 */
export const useApplyCostUnitLabel = () => {
  setCostUnitLabel(useQueryPublicSystemSettings().data?.cost_unit_label ?? "");
};
